import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Livreurs from '@/features/livreurs'

export const Route = createFileRoute('/_authenticated/livreurs/')({
  component: Livreurs,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Livreurs`,
      },
    ],
  }),
})
